import type { IndicatorPeriod } from '@Application/Indicators/IndicatorScope';
import { createSignal } from '@verclam/pulsar';

export const DEFAULT_HOME_PERIOD: IndicatorPeriod = 30;

const homePeriodSignal = createSignal<IndicatorPeriod>(DEFAULT_HOME_PERIOD);

export const setHomePeriod = (period: IndicatorPeriod): void => {
	homePeriodSignal.value = period;
};

export default homePeriodSignal;
